<template>
  <section class="mx-auto max-w-3xl py-10 px-6 text-center">
    <h2 class="text-3xl font-extrabold tracking-tight text-slate-800 dark:text-slate-100">Home</h2>
    <p class="mt-3 text-slate-600 dark:text-slate-300">
      Welcome to <span class="font-semibold text-blue-600">Climate</span>. Create more pages in
      <code class="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-sm text-slate-700">src/pages</code>.
    </p>
    <div class="mt-6 inline-flex gap-3">
      <a href="#" class="rounded-md bg-blue-600 px-4 py-2 text-white shadow hover:bg-blue-700 active:bg-blue-800">Primary</a>
      <a href="#" class="rounded-md border border-slate-300 px-4 py-2 text-slate-700 hover:bg-slate-50">Secondary</a>
    </div>
    <p class="mt-6 text-sm text-slate-500">API: {{ apiMessage }}</p>
  </section>
  
</template>

<script>
import { apiFetch, API_BASE_URL } from '../api/client'
export default {
  name: 'HomePage',
  data() {
    return { apiMessage: 'Checking…' }
  },
  async mounted() {
    try {
      const res = await apiFetch('/api/ping')
      const json = await res.json()
      this.apiMessage = `${json.message} @ ${json.timestamp} (${API_BASE_URL || 'same-origin'})`
    } catch (e) {
      this.apiMessage = `Error: ${e.message}`
    }
  }
}
</script>

<style scoped>
/* You can still add component-scoped styles if needed */
</style>
